import Button from 'react-bootstrap/Button'
import ListGroup from 'react-bootstrap/ListGroup'
import Modal from 'react-bootstrap/Modal'

function DeviceKeysModal({ show, handleClose, selectedRecord }) {

	if (selectedRecord == null) {
		return
	}

	return (
		<Modal
			show={show}
			onHide={handleClose}
			>
				<Modal.Header closeButton>
					<Modal.Title>Device Keys</Modal.Title>
				</Modal.Header>
				<Modal.Body>
				<ListGroup>
					<ListGroup.Item>{selectedRecord.deviceStatusDeviceKey0}</ListGroup.Item>
					<ListGroup.Item>{selectedRecord.deviceStatusDeviceKey1}</ListGroup.Item>
					<ListGroup.Item>{selectedRecord.deviceStatusDeviceKey2}</ListGroup.Item>
					<ListGroup.Item>{selectedRecord.deviceStatusDeviceKey3}</ListGroup.Item>
					<ListGroup.Item>{selectedRecord.deviceStatusDeviceKey4}</ListGroup.Item>
					<ListGroup.Item>{selectedRecord.deviceStatusDeviceKey5}</ListGroup.Item>
				</ListGroup>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={handleClose}>Close</Button>
			</Modal.Footer>
		</Modal>
    )
}

export default DeviceKeysModal